import { Apis } from "../../../lib/Apis";

const unwrapResponseBody = (body) => {
  if (body == null) return null;
  if (body?.success === false) {
    throw new Error(body?.message || "Request failed.");
  }
  if (
    body &&
    typeof body === "object" &&
    "data" in body &&
    ("success" in body || "statusCode" in body)
  ) {
    return body.data;
  }
  return body;
};

const unwrapList = (body) => {
  const payload = unwrapResponseBody(body) ?? body ?? {};
  if (Array.isArray(payload?.data)) return payload.data;
  if (Array.isArray(payload)) return payload;
  return [];
};

export const popularCorporateInteriorDesign = () => {
  const addPopularCorporateInteriorDesign = async (data) => {
    try {
      const response = await Apis.addPopularCorporateInteriorDesign(data);
      return unwrapResponseBody(response?.data) ?? response?.data;
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const getAllCorporateInteriorDesigns = async (setCorporateInteriorDesignData) => {
    try {
      const response = await Apis.getAllCorporateInteriorDesigns();
      const items = unwrapList(response?.data);
      setCorporateInteriorDesignData(items);
      return { data: items, ...(unwrapResponseBody(response?.data) || {}) };
    } catch (error) {
      console.error(error);
      throw error;
    }
  };

  const getAllCorporateInteriorDesignNamesForPopularDesign = async (
    setCorporateInteriorDesignNames,
  ) => {
    try {
      const response = await Apis.getAllCorporateInteriorDesignNamesForPopularDesign();
      const items = unwrapList(response?.data);
      setCorporateInteriorDesignNames(items);
      return { data: items };
    } catch (error) {
      console.error(
        "Error fetching corporate interior design names for popular design:",
        error,
      );
      throw error;
    }
  };

  return {
    addPopularCorporateInteriorDesign,
    getAllCorporateInteriorDesigns,
    getAllCorporateInteriorDesignNamesForPopularDesign,
  };
};
